import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2024 Intract.io</p>
    </footer>
  );
}

export default Footer;
